import { useEffect, useState } from "react"
import { Socket } from "socket.io-client"

type useSocketRoomProps = {
    socket: Socket
    room: number | string | undefined
    joinRoom?: string
    leaveRoom?: string
}

export const useSocketRoom = ({ socket, room, joinRoom="track", leaveRoom="untrack" }: useSocketRoomProps) => {
    const [previousRoom, setPreviousRoom] = useState<number | string | undefined>()

    useEffect(() => {
        // Leave the old room
        if (previousRoom && previousRoom !== room) {
            socket.emit(leaveRoom, previousRoom)
        }

        // Join the new room
        if (room !== undefined && (!previousRoom || previousRoom !== room)) {
            socket.emit(joinRoom, room)
            setPreviousRoom(room)
        }

    }, [joinRoom, leaveRoom, previousRoom, room, socket])

    // Re-emit track after reconnect — server-side rooms are cleared on disconnect
    useEffect(() => {
        const onReconnect = () => {
            if (room !== undefined) {
                socket.emit(joinRoom, room)
            }
        }

        socket.on("connect", onReconnect)
        return () => {
            socket.off("connect", onReconnect)
        }
    }, [joinRoom, room, socket])
}
